import { FmsApi } from "../fmsapi"
import type {
  MEM_sr_RegistAvailableCheck,
  MEM_sr_VisitorByMobile,
  Registration,
  ApiResponse,
  RegistrationResponse,
  RegistrationInfo,
  VST_sd_FAIR_MASTER_POLL,
} from "../models/responsedto"
import BaseController from "./base"

export class MembershipController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "membership")
  }

  public async MEM_sr_RegistAvailableCheck(FAIR_ID: number): Promise<MEM_sr_RegistAvailableCheck> {
    return await this.callApi("MEM_sr_RegistAvailableCheck", { FAIR_ID })
  }

  public async sendVerificationCode(check_type: string, check_target: string, fair_id: number): Promise<ApiResponse> {
    return await this.callApi("sendVerificationCode", { check_type, check_target, fair_id })
  }

  public async sendVerificationCodeToEmail(email: string, template: string, fair_id: number): Promise<ApiResponse> {
    return await this.callApi("sendVerificationCodeToEmail", { email, template, fair_id })
  }

  public async preRegistration(info: Registration): Promise<RegistrationResponse> {
    // const ip_addr = await this.getIP()
    return await this.callApi("MEM_in_OnPlaceVisitor_Prereg", info)
  }

  public async onSiteRegistration(info: Registration): Promise<RegistrationResponse> {
    // const ip_addr = await this.getIP()
    return await this.callApi("MEM_in_OnPlaceVisitor", info)
  }

  public async preRegistrationEng(info: Registration): Promise<RegistrationResponse> {
    // const ip_addr = await this.getIP()
    return await this.callApi("MEM_in_OnPlaceVisitor_Eng", info)
  }

  public async checkRegistrationStatus(fair_id: number): Promise<ApiResponse> {
    return await this.callApi("checkRegistrationStatus", { FAIR_ID: fair_id })
  }

  public async checkInvitationEligibilityAndInfo(fair_id: number): Promise<ApiResponse> {
    return await this.callApi("checkInvitationEligibilityAndInfo", { FAIR_ID: fair_id })
  }

  public async verifyCodeAndFetchApplicationInfo(
    check_type: string,
    check_target: string,
    check_code: string,
    fair_id: number,
    fair_master_id: number,
  ): Promise<{
    VisitorInfo: MEM_sr_VisitorByMobile
    State: string
    VisitorMasterPoll: VST_sd_FAIR_MASTER_POLL[]
    Token: string
  }> {
    return await this.callApi("verifyCodeAndFetchApplicationInfo", { check_type, check_target, check_code, fair_id, fair_master_id })
  }

  public async verifyApplicationAndFetchPaymentInfo(fair_id: number): Promise<ApiResponse<RegistrationInfo>> {
    return await this.callApi("verifyApplicationAndFetchPaymentInfo", { FAIR_ID: fair_id })
  }

  public clearRequestInfo(params: { fair_visitor_id: number; update_user: string; payment_order_id?: number | null }): Promise<ApiResponse> {
    return this.callApi("clearRequestInfo", {
      FAIR_VISITOR_ID: params.fair_visitor_id,
      PAYMENT_ORDER_ID: params.payment_order_id,
      UPDATE_USER: params.update_user,
    })
  }

  public async checkPreregistered(
    mobile: string,
    fair_id: number,
  ): Promise<{
    State: string
    MEM_sr_VisitorByMobile?: MEM_sr_VisitorByMobile
  }> {
    return await this.callApi("MEM_sr_VisitorByMobile", { mobile: mobile, fair_id: fair_id })
  }

  public async MEM_sr_VisitorReqRegistCheck(FAIR_ID: number, VISITOR_ID: number): Promise<ApiResponse> {
    return await this.callApi("MEM_sr_VisitorReqRegistCheck", { FAIR_ID: FAIR_ID, VISITOR_ID: VISITOR_ID })
  }
}
